import { hasPaperForm } from '@ally/transfer-account-utils';
var getIsIraPaperForm = function (account) {
    return !!account && hasPaperForm(account);
};
export default getIsIraPaperForm;
//# sourceMappingURL=getIsIraPaperForm.js.map